import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { requestAsync } from '../../../queries/actions';
import { updateProfilePaymentMethodRequest } from '../../../queries/payment';
import {
  selectBootstrapConfig,
  selectSubscriberConfig,
  selectSubscriptionList
} from '../../../queries/selectors/bootstrap';
import { selectCurrentContentId, selectCurrentContent } from '../../../queries/selectors/contents';
import {
  selectPaymentMethods,
  selectCurrentPaymentMethod,
  selectCurrentContentPPVId
} from '../../../queries/selectors/payment';
import { selectCountryCode } from '../../../queries/selectors/subscriptions';
import { selectShoppingCartConfig } from '../../../queries/selectors/shoppingCart';
import { sendTransactionRequest, updatePlanSubscription, upgradeAddOnSubscriptions } from '../../../queries/subscription';
import { selectClient, selectCountry, selectSearchObj } from '../../../global-selectors';
import { selectDeviceCountry, selectUserData } from '../../../queries/selectors/user';
import { getPaymentMethodsByUser, NewPaymenthMethodsToUser } from '../../../queries/paymentMethods';
import { getCustomerBySubscriber } from '../../../queries/customer';

const mapStateToProps = (state) => {
  return {
    contentId: selectCurrentContentId(state),
    deviceCountry: selectDeviceCountry(state),
    config: selectBootstrapConfig(state),
    userData: selectUserData(state),
    client: selectClient(state),
    content: selectCurrentContent(state),
    countryCode: selectCountryCode(state),
    country: selectCountry(state),
    currentContentPPVId: selectCurrentContentPPVId(state),
    subscriberConfig: selectSubscriberConfig(state),
    paymentMethods: selectPaymentMethods(state),
    currentPaymentMethod: selectCurrentPaymentMethod(state),
    shoppingCart: selectShoppingCartConfig(state),
    subscriptions: selectSubscriptionList(state),
    searchParams: selectSearchObj(state)
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  updateProfilePaymentMethod: (data) => requestAsync(updateProfilePaymentMethodRequest, data),
  sendTransaction: (data) => requestAsync(sendTransactionRequest, data),
  upgradeAddOnSubscriptions: (data) => requestAsync(upgradeAddOnSubscriptions, data),
  updatePlanSubscription: (data) => requestAsync(updatePlanSubscription, data),
  newPaymentMethod: (data) => requestAsync(NewPaymenthMethodsToUser, data),
  getPaymentMethodsByUser: (data) => requestAsync(getPaymentMethodsByUser, data),
  getCustomerBySubscriber: (data) => requestAsync(getCustomerBySubscriber, data),
}, dispatch);


const enhancer = compose(
  connect(mapStateToProps, mapDispatchToProps)
);

export default enhancer;
